<template>
  <b-container>
    <b-row>
      <b-col>
        <b-row class="py-4">
          <b-col
            :cols="5"
            class="text-center"
          >
            <b-img
              fluid
              :src="score.match.team1.image_url"
              :class="$style.teamImage"
              rounded="circle"
            />
          </b-col>
          <b-col
            :cols="2"
            class="d-flex flex-column align-items-center justify-content-center text-center"
          >
            <span
              v-if="score.match.location"
              class="pt-4"
            >
              {{ score.match.location[$i18n.locale] }}
            </span>
          </b-col>
          <b-col
            :cols="5"
            class="text-center"
          >
            <b-img
              fluid
              :src="score.match.team2.image_url"
              :class="$style.teamImage"
              rounded="circle"
            />
          </b-col>

          <b-col
            :cols="5"
            class="text-center"
          >
            <span :class="$style.teamName">
              {{ score.match.team1.display_name[$i18n.locale] }}
              <span :class="$style.fullTeamName">
                {{ score.match.team1.name[$i18n.locale] }}
              </span>
            </span>
          </b-col>
          <b-col
            :class="[
              $style.resultWrapper,
              'py-3'
            ]"
            :cols="2"
          >
            <span v-if="score.match.score_team1 && score.match.score_team2">
              {{ score.match.score_team1 }} - {{ score.match.score_team2 }}
            </span>
            <span v-else>
              - : -
            </span>
          </b-col>
          <b-col
            :cols="5"
            class="text-center"
          >
            <span :class="$style.teamName">
              {{ score.match.team2.display_name[$i18n.locale] }}
              <span :class="$style.fullTeamName">
                {{ score.match.team2.name[$i18n.locale] }}
              </span>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="pb-4">
      <b-col
        :cols="5"
        class="d-flex justify-content-center align-items-center"
      >
        <div class="d-flex justify-content-center">
          <BaseScoreInput
            :class="$style.teamScoreInput"
            :value="score.score_team1 === null ? '-' : score.score_team1"
            readonly="readonly"
          />
        </div>
      </b-col>
      <b-col
        :cols="2"
        :class="[
          'd-flex flex-column text-center align-items-center justify-content-center text-uppercase',
          $style.myPickText
        ]"
      >
        <div
          v-for="athlete in athletes"
          :key="`athlete-${athlete.athlete.id}`"
          class="d-flex flex-column align-items-center text-align-center pt-3"
        >
          <BaseAthleteScoreCircle
            v-if="athlete.athlete"
            :id="athlete.athlete.id"
            :name="athlete.athlete.last_name"
            :score="athlete.athlete.round_score"
            :avatar="athlete.athlete.image"
            :showdetail="true"
          />
          <BaseAthleteScoreCircle v-else />
        </div>
      </b-col>
      <b-col
        :cols="5"
        class="d-flex justify-content-center align-items-center"
      >
        <div class="d-flex justify-content-center">
          <BaseScoreInput
            :class="$style.teamScoreInput"
            :value="score.score_team2 === null ? '-' : score.score_team2"
            readonly="readonly"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { format } from 'date-fns'
import BaseScoreInput from '@/pages/RoundDetail/Components/Atoms/BaseScoreInput'
import BaseAthleteScoreCircle from '@/components/Atoms/BaseAthleteScoreCircle'
export default {
  name: 'TheSummerScoreOverview',
  components: {
    BaseScoreInput,
    BaseAthleteScoreCircle,
  },
  props: {
    score: {
      type: Object,
      default: () => {},
    },
    athletes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    startDate() {
      return format(this.score.match.start, 'DD/MM/YY')
    },
    startTime() {
      return format(this.score.match.start, 'HH:mm')
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .teamImage {
    max-height: 50px;
  }
  .teamName {
    display: block;
    padding: 1rem 0;
    color: $color-midnight-blue;
    font-size: $font-size-xlarge;
    .fullTeamName {
      display: block;
      font-size: $font-size-small;
    }
  }
  .teamScoreInput{
    max-width: 70px;
  }
  .resultWrapper{
    display: flex;
    justify-content: center;
  }
  .resultWrapper span{
    font-weight: bold;
  }
  .backgroundWin{
    background-color: green!important;
  }
  .backgroundLost{
    background-color: red!important;
  }
</style>
